import React from "react";
import {
  FixedWidth,
  PagesHeading,
  ActivityFixedWidth
} from "../../../../CommonComponents/commonStyles";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Content,StyledLoader } from "./style";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { Row, Col } from "antd";
import {
  resetData,
  fetchGrantsActivity,
  fetchLazyData,
  fetchRecurringLazyData,
  setScroll
} from "./actions";
import {
  ExchangeContainer,
  NoteBox,
  FundSummaryContainer,
  FundSummaryContent,
  PageAccountSummary,
  Label,
  Number,
  Para
} from "./style";
import { FundNameWrapper, AccountIdWrapper} from "../../../Contributions/Pages/ContributionActivity/styles";
import ContentComponent from "./Component/ContentComponent/ContentComponent";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import { availableBalance } from '../../../../actions/globalActions';
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { PrimaryButtonComponent } from "../../../../CommonComponents/commonStyles";
import { Blocks } from "./Component/RenderTable/style";
import { todayDate } from "../../../../utils/commonUtil";
import { ContentProvider, ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import { grantActivityDerivedStates } from "./selectors";

const breadcrumbRoutes = () => {
  return [
    {
      routeName: "Home",
      path: "/#"
    },
    {
      routeName: "Grants",
      path: "/grants"
    },
    {
      routeName: "Grant Activity",
      path: "/grants/activity"
    }
  ];
};

export class GrantsActivity extends React.Component {
  constructor(props) {
    super(props);
    this.pageTitle="Grant Activity";
    this.state = {
      pageNo: 0,
      grantPageNo:0,
      pageSize: 50,
      loader: false,
      loaderRecTab: false,
      content:
        "This page allows you to review all of your grant activity. You can search your grant history by date, status, time frame, or charity name. The page will load 50 of the most recent transactions. To see more grant transaction history, click the load more button below."
    };
   

    this.userData = JSON.parse(sessionStorage.getItem("primaryAccount"));
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.DP_APIS();
  }

  //Lazy API
  PAGINATE_API() {
   
    this.setState(prevState => {
      return { grantPageNo: prevState.grantPageNo + 50,
               pageSize: prevState.pageSize + 50  }
    }, () => {
      
      return this.props.getLazyData({
        method: "GET",
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/findSingleGrantByAccountIdStartDateAndEndDate?startDateStr=10/10/1971&&endDateStr=${todayDate()}&isExport=true&pageStart=${this.state.grantPageNo}&pageSize=${this.state.pageSize}`,
        page: "grantsActivity"
      });

  });

  }

  //Load more Recurring Grants
  loadMoreRecurringGrants = () => {
  
    this.setState(prevState => {
      return { pageNo: prevState.pageNo + 50 }
    }, () => {
      

       return this.props.getRecurringLazyData({
        method: "GET",
          url: `/donor-portal/api/grant/${getPrimaryAccount().userId
            }/getRecurringGrantListByAccount?pageStart=${this.state.pageNo}&pageSize=50`,
          page: "grantsActivity"
      });

  });

  }
  //APIS
  DP_APIS() {
    return this.props.requestData({
      metaData: [
        {
          method: "GET",
          url: `/donor-portal/api/grant/${
            getPrimaryAccount().userId
          }/findSingleGrantByAccountIdStartDateAndEndDate?startDateStr=10/10/1971&&endDateStr=${todayDate()}&isExport=true&pageStart=0&pageSize=50`,
          page: "grantsActivity"
        }, 
        {
          method: "GET",
          url: `/donor-portal/api/grant/${
            getPrimaryAccount().userId
          }/getRecurringGrantListByAccount?pageStart=0&pageSize=50`,
          page: "grantsActivity"
        },
        {
          method: "GET",
          url: `/donor-portal/api/grantAgreement/${
            getPrimaryAccount().userId
          }/findGrantAgreementsByAccountIdAndStartDateAndEndDate?startDateStr=10/10/1971&endDateStr=${todayDate()}`,
          page: "grantsActivity"
        }
      ]
    });
  }

  componentWillReceiveProps(np) {
    if (np.cancelData !== this.props.cancelData) {
      this.DP_APIS();
      this.PAGINATE_API();
      this.props.getAvailableBalance(this.findBalance());
    } else if (np.cancel !== this.props.cancel) {
      this.DP_APIS();
      this.PAGINATE_API();
      this.props.getAvailableBalance(this.findBalance());
    }

    if (np.accountID !== this.props.accountID) {
      this.props.reset();
      this.DP_APIS();
      this.PAGINATE_API();
    }
  }

  renderFundSummary(obj) {
    return (
      <FundSummaryContainer>
        <FundSummaryContent>
          <PageAccountSummary>
            <ActivityFixedWidth>
              <Label><FundNameWrapper>{this.userData.accountName}</FundNameWrapper></Label>
            </ActivityFixedWidth>
            <Number><AccountIdWrapper>{this.userData.accountNumber}</AccountIdWrapper></Number>
          </PageAccountSummary>
        </FundSummaryContent>
      </FundSummaryContainer>
    );
  }

  findBalance = () => ({
    metaData: [
      {
        method: 'GET',
        url: `/donor-portal/api/account/${
          getPrimaryAccount().userId
          }/findBalance`
      }
    ]
   });

   setTitle = (title) => {
     this.pageTitle = title;
   }

  render() {
    const { isLoadingSingleGrants, isLoadingRecurringGrants  } = this.props;
    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION,Types.PAGE_ALERTS]} pages={['Grant Activity']}>
        <ExchangeContainer id="grants" className="Analytics_GrantActivity">
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={breadcrumbRoutes()} />
            <div>
              <PagesHeading role="heading" aria-level="1" aria-expanded="false">
                <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Grant Activity" property="field_page_title" defaultMessage={<Preloader styling="btnLoader" />} setTitle={this.setTitle} />
              </PagesHeading>
              {this.userData && this.renderFundSummary()}
              <Row>
                <Col lg={18} md={18} xs={24}>
                  <Content>
                    <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Grant Activity" property="description__value" html={true} />
                  </Content>
                </Col>
              </Row>
            </div>
            {this.props.singleGrants && this.props.singleGrants.singleGrants && this.props.recurringGrants && this.props.recurringGrants.recurringGrant ? <ContentComponent
              grantTab={
                this.props.location.state
                  ? this.props.location.state.grantTab
                  : null
              }
              user={this.userData}
              page={this.pageTitle}
              contentType={"alert_messages"} 
              page={'Grant Activity'}
            />:<Preloader/>}
            {this.props.tabs === "1" && this.props.avail &&
             this.props.singleGrants.singleGrants && this.props.recurringGrants && this.props.recurringGrants.recurringGrant && this.props.singleGrants.dataAvailableForNextRequest && (
              <>
                <Para h={60}>Showing last {this.state.pageSize} transactions or less</Para>
                <Blocks h={50} flex center>
                  <PrimaryButtonComponent
                  disabled={isLoadingSingleGrants?true:false}
                  id="btnLoadMore"
                    onClick={() => {
                      this.PAGINATE_API();
                     // this.setState({ loader: true });
                    }}
                    width={"20%"}
                  >
                    LOAD MORE &nbsp;
                    {isLoadingSingleGrants && (
                      <StyledLoader type="loading" />
                    )}
                  </PrimaryButtonComponent>
                </Blocks>
              </>
            )}       

             {this.props.tabs === "2" && this.props.avail &&
              this.props.recurringGrants && this.props.recurringGrants.recurringGrant && this.props.recurringGrants.dataAvailableForNextRequest && (
                <>
                  <Para h={60}>Showing last {this.state.pageNo == 0?50:this.state.pageNo+50} transactions or less</Para>
                  <Blocks h={50} flex center>
                    <PrimaryButtonComponent
                     disabled={isLoadingRecurringGrants?true:false}
                      id="btnLoadMore"
                      onClick={() => {
                        this.loadMoreRecurringGrants();
                        this.setState({ loaderRecTab: true });
                        
                      }}
                      width={"20%"}
                    >
                       LOAD MORE &nbsp;
                      {isLoadingRecurringGrants && (
                        <StyledLoader type="loading" />
                      )}
                    </PrimaryButtonComponent>
                  </Blocks>
                </>
              )}     
          </FixedWidth>
        </ExchangeContainer>
      </ContentProvider>
    );
  }
}

const mapStateToProps = state => ({
  ...grantActivityDerivedStates(state.toJS()),
});

export const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchGrantsActivity(data)),
  reset: data => dispatch(resetData(data)),
  getLazyData: data => dispatch(fetchLazyData(data)),
  //recurring grants 
  getRecurringLazyData: data => dispatch(fetchRecurringLazyData(data)),
  setScrollTop: data => dispatch(setScroll(data)),
  getAvailableBalance: data => dispatch(availableBalance(data)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GrantsActivity)
);